














import { Component, Prop, Watch } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { mixins } from 'vue-class-component'
import { MediaComponentProps } from '@/components/common/videoCallRoom/VideoCallRoomContainer.vue'
import HavingWebRTCMediaMixin from '@/mixins/webrtc/havingWebRTCMediaMixin'

@Component
export default class VideoCallMainScreen extends mixins(
  HavingWebRTCMediaMixin
) {
  @Prop(Object) participant!: MediaComponentProps
  @Prop(Boolean) on!: boolean

  $store!: ExStore
  videoKey = 0

  get localVideoActive() {
    return this.$store.getters['videoCallRoom/videoActive']
  }

  get shareScreenActive() {
    return this.$store.getters['videoCallRoom/shareScreenActive']
  }

  get screenActive() {
    return this.participant.isLocal
      ? this.localVideoActive
      : !this.remoteVideoSignalMuted
  }

  @Watch('participant')
  handleChagneParticipants(
    newParticipant: MediaComponentProps,
    oldParticipant: MediaComponentProps
  ) {
    oldParticipant.stream
      .getVideoTracks()
      .forEach(track => this.detachRemoteVideoSignalListeners(track))
    newParticipant.stream
      .getVideoTracks()
      .forEach(track => this.attachRemoteVideoSignalListeners(track))

    this.videoKey++

    this.$nextTick(() => {
      this.attachStream(newParticipant.stream, true)
    })
  }

  @Watch('on')
  handleChangeOn(value: boolean) {
    const participant = this.participant
    if (value) {
      this.attachStream(participant.stream, true)
      participant.stream
        .getVideoTracks()
        .forEach(track => this.attachRemoteVideoSignalListeners(track))
    } else {
      participant.stream
        .getVideoTracks()
        .forEach(track => this.detachRemoteVideoSignalListeners(track))
      const media = this.$refs.media as HTMLVideoElement
      media.srcObject = null
    }
  }

  mounted() {
    if (this.on) {
      const { stream } = this.participant
      this.initialize(stream, true)
    }
  }
}
